import React from 'react'
import PropTypes from 'prop-types'

const FilterFormLabel = props => {
  const { id, htmlFor, labelText, children } = props

  return (
    <div className="form-visible-field form-field" id={id}>
      <div className="form-label-container form-div-label-container">
        <label htmlFor={htmlFor}>{labelText}</label>
      </div>
      <div className="form-control-container form-div-control-container">
        {children}
      </div>
    </div>
  )
}

FilterFormLabel.propTypes = {
  id: PropTypes.string,
  htmlFor: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
}

export default FilterFormLabel
